const base64UrlDecode = (input: string) => {
    // Replace non-url compatible chars with base64 standard chars
    const base64 = input.replace(/-/g, '+').replace(/_/g, '/');
    
    // Pad out with standard base64 required padding characters
    const padLength = (4 - input.length % 4) % 4;
    const padded = base64 + '='.repeat(padLength);

    // Decode base64
    const raw = atob(padded);

    // Convert raw output to a UTF-8 string (assuming UTF-8 encoded JSON)
    try {
      return decodeURIComponent(raw.split('').map(c => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
    } catch (err) {
      // Handle potential URIError from malformed characters
      console.error('Failed to decode token:', err);
      return '';
    }
  };
  
// const decodeJWT = (token: string) : JWTDecode => {
//     const parts = token.split('.');

//     if (parts.length !== 3) {
//         throw new Error('JWT must have 3 parts');
//     }

//     const header = JSON.parse(base64UrlDecode(parts[0]));
//     const payload = JSON.parse(base64UrlDecode(parts[1]));

//     return {
//         header: header,
//         payload: payload,
//         signature: parts[2] // Signature is not decoded
//     };
// }

function decodeJWT(token: string) {  
    const parts = token.split('.');
    if (parts.length !== 3) {
      throw new Error('Invalid JWT: The token must have three parts');
    }
  
    const header = JSON.parse(base64UrlDecode(parts[0]));
    const payload = JSON.parse(base64UrlDecode(parts[1]));
    const signature = parts[2]
  
    return { header, payload, signature };
  }

export default decodeJWT;